import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { Checkbox } from '../../../ui/checkbox'
import { colors } from '../../../../utilities/colors'
import UnitRow from '../../Units/UnitRow'

export default function VehiclesStep({ units, allOperable, onAllOperableChange }) {
  const { t } = useTranslation()

  return (
    <Box display="flex" flexDirection="column" w="full" gap={3}>
      <Text fontSize="sm" color={colors.grey300} textAlign="center">
        {t('Confirm your vehicles')}
      </Text>
      <Box
        w="full"
        borderRadius="md"
        border="1px solid"
        borderColor={colors.grey700}
        overflow="hidden"
      >
        {units.map((unit) => (
          <UnitRow key={unit.id} unit={unit} />
        ))}
      </Box>
      <Box
        w="full"
        px={3}
        py={2}
        borderRadius="md"
        border="1px solid"
        borderColor={allOperable ? colors.green : colors.grey700}
      >
        <Checkbox
          checked={allOperable}
          onCheckedChange={({ checked }) => onAllOperableChange(!!checked)}
          css={{
            '& [data-part="control"][data-state=checked]': {
              bg: colors.green,
              borderColor: colors.green,
            },
          }}
        >
          <Text fontSize="xs" color={colors.grey300}>
            {t('All vehicles in this order are operable')}
          </Text>
        </Checkbox>
      </Box>
    </Box>
  )
}
